/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
// eslint-disable-next-line no-unused-vars
import React, { Component } from 'react'
import { connect } from 'react-redux'
import './DownloadPage.css'
import {Link} from 'trux'
import * as links from '../../util/links'
import moment from 'moment'
import {webApi} from '../../lib/WebApi'
import leftArrow from '../../assets/img/left-arrow.svg'

class DownloadPageComp extends Component {
    constructor(props) {
        super(props)
        this.state = { game: null, loading: false }
    }

    componentDidMount() {
        if(!this.state.game) {
            this.setState({loading: true})
            webApi.getGame(this.props.gameId)
                .then((game) => {
                    this.setState({game: game, loading: false})
                })
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!this.state.game && !this.state.loading) {
            this.setState({loading: true})
            webApi.getGame(this.props.gameId)
                .then((game) => {
                    this.setState({game: game, loading: false})
                })
        }
    }

    render() {
        let homeTeam = '--'
        let awayTeam = '--'
        let homeScore = 0
        let awayScore = 0
        let matchDate = '--'
        let backUrl = ''
        let baseUrl =  process.env.REACT_APP_TRACE_ENV.includes('testing') ? 'https://soccer-testing-webapp.s3.amazonaws.com/api/teams' : `${process.env.REACT_APP_API}/teams`;
        let homeTeamSlug = this.props.teamName
        let game = this.state.game

        if(game) {
            homeTeam = game.home_team.title
            awayTeam = game.away_team.title
            homeScore = game.home_team.score
            awayScore = game.away_team.score
            matchDate = moment.utc(game.date).format('M/D/YYYY @ h:mma')
            backUrl = `${baseUrl}/${this.props.teamName}/games/${game.home_team.name}-${this.props.gameId}`
            homeTeamSlug = game.home_team.name
        }

        return (
            <div className="download-page">
                <div className="centered">
                    <div className="content">
                        <Link className="back-ref paragraph1b" to={links.gamesUrl(homeTeamSlug)}>
                            <img src={leftArrow} alt='<'/>My matches</Link>
                        <div className="warn"><p className="paragraph1r"><span className="paragraph1b">Video only results: </span>TRACE-BOT could not personalize this game for your players.</p></div>
                        <h3 className="heading3b" style={{marginTop: '24px'}}>Match</h3>
                        <div className="row">
                            <div className="names">
                                <span className="paragraph1b">{homeTeam}</span>
                                <span className="paragraph1r">{awayTeam}</span>
                            </div>
                            <div className="values">
                                <span className="paragraph1b">{homeScore}</span>
                                <span className="paragraph1r">{awayScore}</span>
                            </div>
                        </div>
                        <span className="paragraph2r">{matchDate}</span>
                        <h3 className="heading3b">Video</h3>
                        <div className="row video">
                            <div className="video-container">
                                <span className="paragraph1r">1st half video</span>
                                <div className="video-back" style={{backgroundImage: 'url('+backUrl+'/poster.jpg)'}}/>
                                <a className="image" href={`${backUrl}/gamevideo1.mp4`} target="_blank" rel="noopener noreferrer">video1</a>
                            </div>
                            <div className="video-container">
                                <span className="paragraph1r">2nd half video</span>
                                <div className="video-back" style={{backgroundImage: 'url('+backUrl+'/poster.jpg)'}}/>
                                <a className="image" href={`${backUrl}/gamevideo2.mp4`} target="_blank" rel="noopener noreferrer">video2</a>
                            </div>
                        </div>
                        <h3 className="heading3b">TRACE-BOT report</h3>
                        <div className="names">
                            <div className="paragraph1r check-ok"><span className="paragraph1b">Trace Cam Video </span>(panning and zooming, downloadable halves)</div>
                            <div className="paragraph1r check-fail"><span className="paragraph1b">Tracers Data </span>(personalized moments playlists, performace metrics)</div>
                        </div>
                        <h3 className="heading3b">Sensorless FAQ</h3>
                        <h4 className="paragraph1b">Why are there no custom playlists?</h4>
                        <div className="paragraph1r text">There are a few possible reasons why TRACE-BOT cannot find data from Tracers:
                            <ol>
                                <li><span className="paragraph1b">Not worn: </span>The Tracers were not used during the game</li>
                                <li><span className="paragraph1b">Power: </span>The Tracers were not turned on during the game, or ran out of battery power during the game</li>
                                <li><span className="paragraph1b">Storage: </span>The Tracers were full and did not have enough space to record</li>
                            </ol>
                        </div>
                        <h4 className="paragraph1b">How to fix this next time?</h4>
                        <div className="paragraph1r text">
                            <ul>
                                <li>Make sure all Tracers stay in the case for 30 seconds after powering the case on and they’re ALL flashing red prior to handing them out to the players</li>
                                <li>Ensure case is fully charged the night before</li>
                                <li>Don’t attempt to Trace more than 3 games in a day</li>
                                <li>Upload/Transfer data after each day’s use</li>
                                <li>Let’s run an Equipment Test!</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, pageProps) => {

    let game = state.game.value
    return {
        rev: new Date().getTime(),
        game: game,
        gameId: pageProps.match.params.game_id,
        teamName: pageProps.match.params.team_name
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

const DownloadPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(DownloadPageComp)

export default DownloadPage
